/**
 * PortalChart
 *
 * 
 * 
 */

// the constructor for this object
function PortalChart() { 
    
    // redraw the chart on window size change
    var chartInstance = this;
    window.addEventListener('resize', function() {
        chartInstance.draw();
    });
    
}

// the object
PortalChart.prototype = {
    constructor: PortalChart,

    // this is set to true once the library has been loaded
    libraryLoaded: false,

    // element id of the html container
    elementId: false,
    
    // type of chart (area, line, donut)
    type: false,

    // the columns to be used
    columns: false,
    
    // data format to be used
    dataFormat: 'number',
    
    // the power to be used when calculating byte and bit data
    dataPower: 1000,
    
    // the min and max date used in timeline charts
    minDate: false,
    maxDate: false,
    
    // the optional minimum values for the low and high values 
    minRangeValue: false,
    maxRangeValue: false,

    // the data of the chart
    data: false,
    
    // the stored formatted data
    formattedData: false,
    
    // properties that are added to rows for use in chart events
    rowProperties: false,
    
    // the callback function to be used when a data point is selected on the chart
    selectEventCallback: false,
    
    // draw the chart
    draw: function()
    {
        // only run this if the library has been loaded
        if (this.libraryLoaded
        && this.data !== false) {
            if (this.type == 'area') {
                this._drawAreaChart();
                
            } else if (this.type == 'line') {
                this._drawLineChart();
                
            } else if (this.type == 'donut') {
                this._drawDonutChart();
                
            }
            
        }
    },
    
    _drawAreaChart: function()
    {
        // clean up the data
        this._formatTimelineData();
            
        var element = document.getElementById(this.elementId);
        
        var options = PortalConfig.chartOptions.timeline;
        
        // set the date format
        this._setDataPointDateFormat();
        var dateFormat = this._getAxisDateFormat();
        options.hAxis.format = dateFormat;
        
        // set the min and max value for the timeline of the chart
        options = this._getTimelineMinMax(options);
        
        // get the ticks for the vAxis
        var ticks = this._getTicks();
        options.vAxis.ticks = ticks;
        
        var chart = new google.visualization.AreaChart(element);
        chart.draw(this.formattedData, options);
    },
    
    _drawLineChart: function()
    {
        // clean up the data
        this._formatTimelineData();
            
        var element = document.getElementById(this.elementId);
        
        var options = PortalConfig.chartOptions.timeline;
        
        // set the date format
        this._setDataPointDateFormat();
        var dateFormat = this._getAxisDateFormat();
        options.hAxis.format = dateFormat;
        
        // set the min and max value for the timeline of the chart
        options = this._getTimelineMinMax(options);
        
        // get the ticks for the vAxis
        var ticks = this._getTicks();
        options.vAxis.ticks = ticks;
        
        var chart = new google.visualization.LineChart(element);
        chart.draw(this.formattedData, options);
    },
    
    _drawDonutChart: function()
    {
        // clean up the data
        this._formatDonutData();
        
        var element = document.getElementById(this.elementId);
        
        var options = PortalConfig.chartOptions.donut;
        
        var chart = new google.visualization.PieChart(element);
        
        //set the callback event if one exists
        if (typeof this.selectEventCallback == 'function') {    
            google.visualization.events.addListener(
                chart, 
                'select', 
                (this._selectEvent)(chart)
            );
        }
        
        chart.draw(this.formattedData, options);
    },
    
    // return a function that handles the select event on a chart
    _selectEvent: function(chart)
    {
        var self = this;
        
        return function() {
            var selectedItem = chart.getSelection()[0];
            if (selectedItem) {
                var rowProperties = self.formattedData.getRowProperties(selectedItem.row);
                self.selectEventCallback(rowProperties);
            }
        }
    },
    
    // clean up the data for use in the google chart
    _formatTimelineData: function()
    {
        var data = new google.visualization.DataTable();
        
        // include the columns
        for (var i in this.columns) {
            var dataType = this.columns[i][0];
            var columnName = this.columns[i][1];
            
            data.addColumn(dataType, columnName);
        }
        
        // remove the header row from the original data
        var formattedData = PortalHelper.cloneArray(this.data);
        formattedData.shift();
        
        // convert the date column from unix timestamp to date instance
        for (var row in formattedData) {
            for (var column in this.columns) {
                
                // the first column of timeline data is a unix timestamp. convert it to a date
                if (column == 0) {
                    var value = formattedData[row][column];
                    value = new Date(value * 1000); 
                    formattedData[row][column] = value;
                }
                
            }
        }
        
        // add the formatted data to the DataTable
        data.addRows(formattedData);
        
        // get the min and max of the data for use in the data formatter
        var min = 0;
        var max = 0;
        for (var row in formattedData) {
            for (var column in this.columns) {
                row = parseInt(row);
                column = parseInt(column);
                
                // ignore the date column
                if (column != 0) {
                    var value = formattedData[row][column];
                    if (value > max) {
                        max = value;
                    }
                    if (value < min) {
                        min = value;
                    }
                }
            }
        }
        if (this.minRangeValue !== false && this.minRangeValue < min) {
            min = this.minRangeValue;
        }
        if (this.maxRangeValue !== false && this.maxRangeValue > max) {
            max = this.maxRangeValue;
        }
        
        // cycle through each data set and format accordingly
        for (var row in formattedData) {
            for (var column in this.columns) {
                
                row = parseInt(row);
                column = parseInt(column);
                
                // ignore the date column
                if (column != 0) {
                    var value = formattedData[row][column];
                    value = this._dataFormatter(value, min, max);
                    data.setFormattedValue(row, column, value);
                }
                
            }
        }
        
        // add the custom row properties to the data
        if (this.rowProperties !== false) {
            for (var i in this.rowProperties) {
                var row = parseInt(i);
                data.setRowProperties(row, this.rowProperties[i]);
            }
        }
        
        this.formattedData = data;
    },
    
    // clean up the data for use in the google chart
    _formatDonutData: function()
    {
        var data = new google.visualization.arrayToDataTable(this.data);
        
        var formattedData = PortalHelper.cloneArray(this.data);
        formattedData.shift();
        
        // cycle through each data set and format accordingly
        for (var i in formattedData) {
            var row = parseInt(i);
            var column = 1;
            
            var value = formattedData[row][column];
            value = this._dataFormatter(value);
            
            data.setFormattedValue(row, column, value);        
        }
        
        // add the custom row properties to the data
        if (this.rowProperties !== false) {
            for (var i in this.rowProperties) {
                var row = parseInt(i);
                data.setRowProperties(row, this.rowProperties[i]);
            }
        }
        
        this.formattedData = data;
    },
    
    // determine the date format based on the timeframe of the data
    _setDataPointDateFormat: function()
    {
        // apply the format the data point tooltips
        var dateFormatter = new google.visualization.DateFormat({ 
            pattern: 'M/d/yy h:mma'
        }); 
        dateFormatter.format(this.formattedData, 0);
    },
    
    // determine the date format based on the timeframe of the data
    _getAxisDateFormat: function()
    {
        // get the start and end date
        if (this.minDate && this.maxDate) {
            var start = this.minDate.getTime();
            var end = this.maxDate.getTime();
        } else {
            var dates = this.formattedData.getColumnRange(0);
            var start = dates.min.getTime();
            var end = dates.max.getTime();
        }
        
        // get the range of dates and the time difference
        var timeDiff = Math.abs(start - end);
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        
        // determine the format
        if (diffDays <= 45){
            var dateFormat = 'M/d/yy';
        } else {
            var dateFormat = 'MMM';
        } 
        
        return dateFormat;
    },
    
    // apply the min and max dates to the hAxis if applicable
    _getTimelineMinMax: function(options)
    {
        if (this.minDate !== false) {
            options.hAxis.minValue = this.minDate; 
        }
        if (this.maxDate !== false) {
            options.hAxis.maxValue = this.maxDate; 
        }
        
        return options;
    },
    
    // get the ticks for a chart based on the column ranges
    _getTicks: function()
    {
        // determine the minimum and the maximum
        var max = -9999999999999999999999999999999999999999999999999999999999999999999;
        var min = 9999999999999999999999999999999999999999999999999999999999999999999;
        for (var i in this.columns) {
            if (i > 0) { // ignore the date column
                
                var columnIndex = parseInt(i);
                var range = this.formattedData.getColumnRange(columnIndex);
                
                if (range.max > max) {
                    max = range.max;
                }
                
                if (range.min < min) {
                    min = range.min;
                }
            }
        }
        
        // set the new min and new max
        var newMin = 0;
        if (min != 0) {
            newMin = min - Math.abs(min * .1);
            if (newMin < 0 && min >= 0) {
                newMin = 0;
            }
        }
        var newMax = 0;
        if (max != 0) {
            newMax = max + Math.abs(max * .1);
        }
        min = newMin;
        max = newMax;
        
        // set up the min and max overrides
        if (this.minRangeValue !== false && this.minRangeValue < min) {
            min = this.minRangeValue;
        }
        if (this.maxRangeValue !== false && this.maxRangeValue > max) {
            max = this.maxRangeValue;
        }
        
        // round min and max to nearest 10th
        min = Math.floor(min / 10) * 10;
        max = Math.ceil(max / 10) * 10;
        
        // set up the ticks based on the min and max of the data
        var difference = max - min;
        
        var ticks = [
            { v: min, f: this._dataFormatter(min, min, max) },
            { v: min + difference * .2, f: this._dataFormatter(min + difference * .2, min, max) },
            { v: min + difference * .4, f: this._dataFormatter(min + difference * .4, min, max) },
            { v: min + difference * .6, f: this._dataFormatter(min + difference * .6, min, max) },
            { v: min + difference * .8, f: this._dataFormatter(min + difference * .8, min, max) },
            { v: min + difference, f: this._dataFormatter(min + difference, min, max) },
        ];
        
        return ticks;
    },
    
    // run the proper formatter on the values
    _dataFormatter: function(value, min, max)
    {
        var dataFormat = this.dataFormat.charAt(0).toUpperCase() + this.dataFormat.slice(1);
        value = this['_dataFormat' + dataFormat](value, min, max);
        
        return value;
    },
    
    // the default data format
    _dataFormatNumber: function(value, min, max)
    {
        var value = PortalHelper.numberWithCommas(value);
        return value;
    },
    
    // format the data into groups (KB, MB, GB, etc)
    _dataFormatBytes: function(value, min, max)
    {   
        // determine the unit of measure by the largest min or max
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
        return this._dataFormatMetric(value, min, max, sizes);
    },
    
    // format the data into groups (Kb, Mb, Gb, etc)
    _dataFormatBits: function(value, min, max)
    {   
        var sizes = ['Bits', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb'];
        return this._dataFormatMetric(value, min, max, sizes);
    },
    
    // format the data into groups (KHz, MHz, GHz, etc)
    _dataFormatHertz: function(value, min, max)
    {   
        var sizes = ['Hertz', 'KHz', 'MHz', 'GHz', 'THz', 'PHz', 'EHz'];
        return this._dataFormatMetric(value, min, max, sizes);
    },
    
    // format the data into metric units
    _dataFormatMetric: function(value, min, max, sizes)
    {
        // determine if it's a negative value, and get the absolute value
        var negative = value < 0 ? true : false;
        value = Math.abs(value);
        
        // determine the unit of measure by the largest min or max
        if (min != 0) {
            var min = parseInt(Math.floor(Math.log(Math.abs(min)) / Math.log(this.dataPower)));
        }
        if (max != 0) {
            var max = parseInt(Math.floor(Math.log(max) / Math.log(this.dataPower)));
        }
        var unitKey = (min > max ? min : max);
        var unitOfMeasure = sizes[unitKey];
        
        // break down into the proper unit of measurement
        if (value == 0) {
            return '0 ' + unitOfMeasure;
        }
        var total = Math.round(value / Math.pow(this.dataPower, unitKey) * 100) / 100;
        
        // apply the negative and format 
        total = negative === true ? total * -1 : total;
        value = total + ' ' + unitOfMeasure;
        
        return value;
    },
    
    // format the data into dollars
    _dataFormatDollars: function(value, min, max)
    {   
        value = value.toFixed(0);
        
        // add commas to the thousand separator
        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        
        // add the currency symbol
        value = '$' + value;
        
        return value;
    },
}
